import { render, staticRenderFns } from "./CompanyReferenceList.vue?vue&type=template&id=44cc691f&"
import script from "./CompanyReferenceList.vue?vue&type=script&lang=js&"
export * from "./CompanyReferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports